import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, mappingResultError, NotFoundError, Result, UseCase } from '@digibricks/core';
import { NoneValue } from '../../../../core';
export var MOVE_QUESTION_USE_CASE = 'MOVE_QUESTION_USE_CASE';

/**
 * Reorder a question via previousQuestionId linked list, optionally across
 * sections / heading boundaries, then persist with PATCH /questions/:id/move.
 */
export var MoveQuestionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(MoveQuestionUseCase, _UseCase);

  var _super = _createSuper(MoveQuestionUseCase);

  function MoveQuestionUseCase(questionRepository) {
    var _this;

    _classCallCheck(this, MoveQuestionUseCase);

    _this = _super.call(this);
    _this.questionRepository = questionRepository;
    return _this;
  }

  _createClass(MoveQuestionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var questionId, rawPreviousQuestionId, sectionId, rawHeadingId, rawNextHeadingId, questions, headings, previousQuestionId, headingId, nextHeadingId, movedQuestion, targetSectionId, sameSection, alreadyInPlace, workingQuestions, workingHeadings, moved, oldPreviousId, oldNext, oldNextId, unlinkOrError, linkOrError, attachOrError, dto, apiOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                questionId = input.questionId, rawPreviousQuestionId = input.previousQuestionId, sectionId = input.sectionId, rawHeadingId = input.headingId, rawNextHeadingId = input.nextHeadingId, questions = input.questions, headings = input.headings;
                previousQuestionId = rawPreviousQuestionId === null || rawPreviousQuestionId === void 0 ? void 0 : rawPreviousQuestionId.trim();

                if (previousQuestionId) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", new BadInputError('previousQuestionId is required'));

              case 4:
                if (!(previousQuestionId === questionId)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", new BadInputError('A question cannot be placed after itself'));

              case 6:
                headingId = (rawHeadingId === null || rawHeadingId === void 0 ? void 0 : rawHeadingId.trim()) || NoneValue;
                nextHeadingId = (rawNextHeadingId === null || rawNextHeadingId === void 0 ? void 0 : rawNextHeadingId.trim()) || NoneValue;

                if (!(headingId !== NoneValue && nextHeadingId !== NoneValue && headingId === nextHeadingId)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", new BadInputError('headingId and nextHeadingId must be different'));

              case 10:
                movedQuestion = questions.find(function (q) {
                  return q.id.toString() === questionId;
                });

                if (movedQuestion) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", new NotFoundError('Question is not existed'));

              case 13:
                targetSectionId = (sectionId === null || sectionId === void 0 ? void 0 : sectionId.trim()) || movedQuestion.sectionId;
                sameSection = targetSectionId === movedQuestion.sectionId;
                alreadyInPlace = sameSection && movedQuestion.previousQuestionId === previousQuestionId;
                workingQuestions = questions.map(function (q) {
                  return q.clone();
                }); // Prefer caller-synced headings (from interleaved order) when provided.

                workingHeadings = headings ? headings.map(function (h) {
                  return h.clone();
                }) : undefined;
                moved = workingQuestions.find(function (q) {
                  return q.id.toString() === questionId;
                });

                if (moved) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt("return", new NotFoundError('Question is not existed'));

              case 21:
                oldPreviousId = moved.previousQuestionId;
                oldNext = workingQuestions.find(function (q) {
                  return q.previousQuestionId === moved.id.toString() && q.id.toString() !== moved.id.toString();
                });
                oldNextId = oldNext === null || oldNext === void 0 ? void 0 : oldNext.id.toString();

                if (alreadyInPlace) {
                  _context.next = 32;
                  break;
                }

                unlinkOrError = this.unlink(moved, workingQuestions);

                if (!unlinkOrError.isFailure) {
                  _context.next = 28;
                  break;
                }

                return _context.abrupt("return", mappingResultError(unlinkOrError));

              case 28:
                if (workingHeadings) {
                  workingHeadings = this.detachFromHeadings(moved.id.toString(), oldPreviousId, oldNextId, workingHeadings);
                }

                linkOrError = this.link(moved, previousQuestionId, targetSectionId, workingQuestions);

                if (!linkOrError.isFailure) {
                  _context.next = 32;
                  break;
                }

                return _context.abrupt("return", mappingResultError(linkOrError));

              case 32:
                moved.updateHeadingId(headingId);
                moved.updateNextHeadingId(nextHeadingId);

                if (!workingHeadings) {
                  _context.next = 40;
                  break;
                }

                // Clear residual pointers before attaching the new boundary.
                // When leaving a heading as its first question (drag above heading),
                // advance nextQuestionId to the old next — do not blank it to none.
                workingHeadings = workingHeadings.map(function (heading) {
                  var clone = heading.clone();

                  if (clone.nextQuestionId === moved.id.toString() && headingId !== clone.id.toString()) {
                    clone.updateNextQuestionId(oldNextId !== null && oldNextId !== void 0 ? oldNextId : NoneValue);
                  }

                  if (clone.previousQuestionId === moved.id.toString() && nextHeadingId !== clone.id.toString()) {
                    clone.updatePreviousQuestionId(NoneValue);
                  }

                  return clone;
                });
                attachOrError = this.attachToHeadings(moved.id.toString(), headingId, nextHeadingId, workingHeadings);

                if (!attachOrError.isFailure) {
                  _context.next = 39;
                  break;
                }

                return _context.abrupt("return", mappingResultError(attachOrError));

              case 39:
                workingHeadings = attachOrError.getValue();

              case 40:
                // headingId / nextHeadingId are @IsUUID on the API — never send "none".
                // Omit the field when clearing; send a real UUID when attaching.
                // previousQuestionId still accepts "none" as the section-head sentinel.
                dto = _objectSpread(_objectSpread(_objectSpread({
                  previousQuestionId: previousQuestionId
                }, sectionId ? {
                  sectionId: targetSectionId
                } : {}), headingId !== NoneValue ? {
                  headingId: headingId
                } : {}), nextHeadingId !== NoneValue ? {
                  nextHeadingId: nextHeadingId
                } : {});
                _context.next = 43;
                return this.questionRepository.move(questionId, dto);

              case 43:
                apiOrError = _context.sent;

                if (!apiOrError.isFailure) {
                  _context.next = 46;
                  break;
                }

                return _context.abrupt("return", mappingResultError(apiOrError));

              case 46:
                return _context.abrupt("return", Result.ok({
                  movedQuestion: moved,
                  questions: workingQuestions,
                  headings: workingHeadings,
                  formVersion: apiOrError.getValue().formVersion
                }));

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }, {
    key: "unlink",
    value: function unlink(moved, questions) {
      var oldNext = questions.find(function (q) {
        return q.previousQuestionId === moved.id.toString() && q.id.toString() !== moved.id.toString();
      });

      if (oldNext) {
        var updateOrError = oldNext.updatePreviousQuestionId(moved.previousQuestionId);

        if (updateOrError.isFailure) {
          return mappingResultError(updateOrError);
        }
      }

      return Result.ok();
    }
  }, {
    key: "link",
    value: function link(moved, previousQuestionId, targetSectionId, questions) {
      if (moved.sectionId !== targetSectionId) {
        var sectionOrError = moved.updateSectionId(targetSectionId);

        if (sectionOrError.isFailure) {
          return mappingResultError(sectionOrError);
        }
      }

      var newNext = questions.find(function (q) {
        return q.id.toString() !== moved.id.toString() && q.sectionId === targetSectionId && q.previousQuestionId === previousQuestionId;
      });
      var prevOrError = moved.updatePreviousQuestionId(previousQuestionId);

      if (prevOrError.isFailure) {
        return mappingResultError(prevOrError);
      }

      if (newNext) {
        var nextOrError = newNext.updatePreviousQuestionId(moved.id.toString());

        if (nextOrError.isFailure) {
          return mappingResultError(nextOrError);
        }
      }

      return Result.ok();
    }
  }, {
    key: "detachFromHeadings",
    value: function detachFromHeadings(questionId, oldPreviousId, oldNextId, headings) {
      return headings.map(function (heading) {
        var clone = heading.clone();
        var isPreviousHeading = clone.nextQuestionId === questionId;
        var isNextHeading = clone.previousQuestionId === questionId;

        if (isPreviousHeading && isNextHeading) {
          clone.updateNextQuestionId(NoneValue);
          clone.updatePreviousQuestionId(NoneValue);
          return clone;
        }

        if (isPreviousHeading) {
          clone.updateNextQuestionId(oldNextId !== null && oldNextId !== void 0 ? oldNextId : NoneValue);
        }

        if (isNextHeading) {
          clone.updatePreviousQuestionId(oldPreviousId && oldPreviousId !== NoneValue ? oldPreviousId : NoneValue);
        }

        return clone;
      });
    }
  }, {
    key: "attachToHeadings",
    value: function attachToHeadings(questionId, headingId, nextHeadingId, headings) {
      var updated = headings.map(function (h) {
        return h.clone();
      });

      if (headingId && headingId !== NoneValue) {
        var heading = updated.find(function (h) {
          return h.id.toString() === headingId;
        });

        if (!heading) {
          return new BadInputError('Heading not found');
        }

        heading.updateNextQuestionId(questionId);
      }

      if (nextHeadingId && nextHeadingId !== NoneValue) {
        var nextHeading = updated.find(function (h) {
          return h.id.toString() === nextHeadingId;
        });

        if (!nextHeading) {
          return new BadInputError('Next heading not found');
        }

        nextHeading.updatePreviousQuestionId(questionId);
      }

      return Result.ok(updated);
    }
  }]);

  return MoveQuestionUseCase;
}(UseCase);